import { requiredUuidString } from '../zod-helpers/index.js';
import { createTransferOrderItemSchema } from './create-input.js';
export const addTransferOrderLineInputSchema = createTransferOrderItemSchema.extend({
    transferOrderId: requiredUuidString('Transfer order id is required.', 'Invalid transfer order id.'),
});
//# sourceMappingURL=add-line-input.js.map